/**
 * ConversationNote — internal note item in the conversation timeline.
 * Uses the amber note-card design from inbox CSS.
 * Props:
 *   item {object} — thread item with type: 'note' and .note sub-object
 */

import { h } from 'preact'
import { timeAgo } from './utils.js'

export function ConversationNote({ item }) {
  const note     = item.note || item
  const initials = (note.person_name || '?').trim()[0]?.toUpperCase() || '?'

  return (
    <div class="note-card" id={`support-note-${note.id}`}>
      <div class="note-card-header">
        {note.avatar_url
          ? (
            <img
              src={note.avatar_url}
              width={26}
              height={26}
              class="note-avatar"
              alt={note.person_name}
              loading="lazy"
            />
          )
          : (
            <div class="note-avatar">{initials}</div>
          )
        }
        <span class="note-author">{note.person_name}</span>
        <span class="note-badge">
          <i class="bi bi-sticky me-1" />
          Belső megjegyzés
        </span>
        <span class="note-time">{timeAgo(note.created_at)}</span>
      </div>
      <div class="note-card-body">{note.body}</div>
    </div>
  )
}
